import React from 'react';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import BaseSubnav, { SubnavGroup } from './BaseSubnav';
import { getPublicPath } from 'utils/paths';

const NewTopbarCompaniesSubnav: React.FC = () => {
  const { t } = useI18n('topbar');
  const { locale } = useRouter();

  const illustration = getPublicPath('/images/topbar/companies-circle.svg');

  const groups: SubnavGroup[] = [
    {
      title: t('freelance_subnav.offer.title'),
      items: [
        {
          text: t('companies_subnav.products.manfred.title'),
          href: getAppUrl(APP_URLS.talentEngineLanding, locale)
        },
        {
          text: t('companies_subnav.products.freelance-companies.title'),
          href: getAppUrl(APP_URLS.freelanceCompanies, locale)
        },
        {
          text: t('companies_subnav.products.daily.title'),
          href: getAppUrl(APP_URLS.manfredDailyCompanies, locale)
        }
      ]
    },
    {
      title: t('companies_subnav.consulting.title'),
      items: [
        {
          text: t('companies_subnav.consulting.marca-empleadora.title'),
          href: `${getAppUrl(APP_URLS.hrAsAService, locale)}#help-feature1`
        },
        {
          text: t('companies_subnav.consulting.employer-branding.title'),
          href: `${getAppUrl(APP_URLS.hrAsAService, locale)}#help-feature1`
        },
        {
          text: t('companies_subnav.consulting.equilibrio-salarial.title'),
          href: `${getAppUrl(APP_URLS.hrAsAService, locale)}#help-feature3`
        },
        {
          text: t('companies_subnav.consulting.plan-carrera.title'),
          href: `${getAppUrl(APP_URLS.hrAsAService, locale)}#help-feature2`
        }
      ]
    },
    {
      title: t('companies_subnav.resources.title'),
      items: [
        {
          text: t('companies_subnav.resources.guia-salarial.title'),
          href: `${getAppUrl(
            APP_URLS.blog,
            locale
          )}/guia-salarial-2026-salarios-en-tecnologia-espana-manfred`
        },

        {
          href: `${getAppUrl(APP_URLS.mantechcar25, locale)}`,
          text: t('companies_subnav.resources.career-report.title')
        },
        {
          href: `${getAppUrl(APP_URLS.successStories, locale)}`,
          text: t('companies_subnav.resources.success-stories.title')
        },
        {
          href: `${getAppUrl(APP_URLS.outOfOffice, locale)}`,
          text: t('companies_subnav.resources.out-of-office.title')
        }
      ]
    }
  ];

  return (
    <BaseSubnav
      illustration={illustration}
      title={
        locale === 'en'
          ? 'We help you hire or improve your HR strategy'
          : 'Te ayudamos a contratar o a mejorar tu estrategia de HR'
      }
      description={t('companies_subnav.growth.desc')}
      cta={{
        text: t('companies_subnav.consultancy.link'),
        href: getAppUrl(APP_URLS.companies, locale)
      }}
      groups={groups}
    />
  );
};

export default NewTopbarCompaniesSubnav;
